.planCard:hover {
  cursor: pointer;
  border: 0.125em solid trasparent; /* 2px */
  background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-primaryDark-7));
}

.selectedCard {
  cursor: pointer;
  border: 0.125em solid light-dark(var(--mantine-color-primary-3), var(--mantine-color-primary-2)); /* 2px */
  background-color: light-dark(var(--mantine-color-primary-0), var(--mantine-color-primaryDark-7));
}

.header {
  height: 10rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-inline: 0.5rem;
}

.footer {
  height: 4.5rem;
  display: flex;
  align-items: center;
  padding-inline: 0.5rem;
  overflow: hidden;
}

.listItem {
  margin-bottom: 0.25rem;
  padding-left: -10px;
}

@media (min-width: 48em) {
  .listItem {
    margin-bottom: 0.5rem;
  }
}
